/*
 * Copyright © 2019 Franck Borel, Martin Helfer, Sebastian Schüpbach
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

/**
 * Displays a row in the result or  list
 */
@Component({
  selector: 'app-search-hit-value',
  template: `

    <span class="search-hit-field-value">

      <span *ngIf="getType(fieldValue) === 'unset'"
            class="search-hit-field-value__unset"
      >
        <i>---</i>
      </span>

      <!-- Wenn es ein Einzelwert ist (z.B. ID, Jahr,...), einfach Wert ausgeben -->
      <span *ngIf="getType(fieldValue) === 'single'"
            class="search-hit-field-value__single"
            [innerHTML]="fieldValue | safeHtml"
      ></span>

      <!-- Wenn es ein Multiwert ist (z.B. Personen, Schlagwoerter,...), Werte aggregiert ausgeben -->
      <span *ngIf="getType(fieldValue) === 'multi'"
            class="search-hit-field-value__multi">
          <ul>
              <li *ngFor="let singleValue of fieldValue, last as last" [innerHTML]="singleValue | safeHtml"></li>
          </ul>
      </span>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchHitValueComponent {
  @Input() fieldValue: any;

// noinspection JSMethodCanBeStatic
  getType(obj) {
    if (!obj) {
      return 'unset';
    } else if (obj.constructor === Array) {
      return "multi";
    } else {
      return "single";
    }
  }

}
